import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BAOCAO_MODULE } from '../constants';
import { Get } from '../../utils/httpProvider';
import { BAOCAO_API } from '../../utils/apiUrl';

export const baoCaoGetTongQuanTeamAction = createAsyncThunk(
  BAOCAO_MODULE.GET_TONG_QUAN_TEAM,
  async (
    { From = '', To = '', includeChuaGanNhom = true } = {},
    { rejectWithValue }
  ) => {
    try {
      const baseUrl = BAOCAO_API.GET_TONG_QUAN_TEAM(includeChuaGanNhom);

      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10); 
        }
        return String(v).trim(); 
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      // append query From/To
      const sp = new URLSearchParams();
      if (f) sp.append('From', f);
      if (t) sp.append('To', t);

      const qs = sp.toString();
      const url = qs
        ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${qs}`
        : baseUrl;

      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Bảng 2
export const baoCaoGetThanhVienTeamAction = createAsyncThunk(
  BAOCAO_MODULE.GET_THANH_VIEN_TEAM,
  async ({ teamId, From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10);
        }
        return String(v).trim();
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      const url = BAOCAO_API.GET_THANH_VIEN_TEAM({ teamId, From: f, To: t });
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// [THÊM] Bảng 3
export const baoCaoGetChiTietNhanVienAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_NHAN_VIEN,
  async ({ filter } = {}, { rejectWithValue }) => {
    try {
      const url = BAOCAO_API.GET_CHI_TIET_NHAN_VIEN(filter);
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietPhatTrienPhanMemAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_PHAT_TRIEN_PHAN_MEM,
  async ({ teamId, From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10);
        }
        return String(v).trim();
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      const url = BAOCAO_API.GET_CHI_TIET_PHAT_TRIEN_PHAN_MEM({
        teamId,
        From: f,
        To: t,
      });

      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietXuLyYeuCauAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_XU_LY_YEU_CAU,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10);
        }
        return String(v).trim();
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      const url = BAOCAO_API.GET_CHI_TIET_XU_LY_YEU_CAU({ From: f, To: t });
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietXuLyYeuCauThanhVienAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_XU_LY_YEU_CAU_THANH_VIEN,
  async ({ filter } = {}, { rejectWithValue }) => {
    try {
      const url = BAOCAO_API.GET_CHI_TIET_XU_LY_YEU_CAU_THANH_VIEN(filter);
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietHoTroAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_HO_TRO,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10);
        }
        return String(v).trim();
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      const url = BAOCAO_API.GET_CHI_TIET_HO_TRO({ From: f, To: t });
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietHoTroThanhVienAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_HO_TRO_THANH_VIEN,
  async ({ filter } = {}, { rejectWithValue }) => {
    try {
      const url = BAOCAO_API.GET_CHI_TIET_HO_TRO_THANH_VIEN(filter);
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietNhiemVuKhacAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_NHIEM_VU_KHAC,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10);
        }
        return String(v).trim();
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      const url = BAOCAO_API.GET_CHI_TIET_NHIEM_VU_KHAC({ From: f, To: t });
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetChiTietNhiemVuKhacThanhVienAction = createAsyncThunk(
  BAOCAO_MODULE.GET_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN,
  async ({ filter } = {}, { rejectWithValue }) => {
    try {
      const url = BAOCAO_API.GET_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN(filter);
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const baoCaoGetTongHopNhanVienAction = createAsyncThunk(
  BAOCAO_MODULE.GET_TONG_HOP_NHAN_VIEN,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizeDate = (v) => {
        if (!v) return '';
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
          return v.toISOString().slice(0, 10);
        }
        return String(v).trim();
      };

      const f = normalizeDate(From);
      const t = normalizeDate(To);

      const url = BAOCAO_API.GET_TONG_HOP_NHAN_VIEN({ From: f, To: t });
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {

  tongQuanTeam: [],
  loading: false,
  error: null,

  thanhVienTeam: [],
  loadingThanhVienTeam: false,
  errorThanhVienTeam: null,

  chiTietNhanVien: null,
  loadingChiTietNhanVien: false,
  errorChiTietNhanVien: null,

  chiTietPhatTrienPhanMem: null,
  loadingChiTietPhatTrienPhanMem: false,
  errorChiTietPhatTrienPhanMem: null,

  chiTietXuLyYeuCau: [],
  loadingChiTietXuLyYeuCau: false,
  errorChiTietXuLyYeuCau: null,

  chiTietXuLyYeuCauThanhVien: [],
  loadingChiTietXuLyYeuCauThanhVien: false,
  errorChiTietXuLyYeuCauThanhVien: null,

  chiTietHoTro: [],
  loadingChiTietHoTro: false,
  errorChiTietHoTro: null,

  chiTietHoTroThanhVien: [],
  loadingChiTietHoTroThanhVien: false,
  errorChiTietHoTroThanhVien: null,

  chiTietNhiemVuKhac: [],
  loadingChiTietNhiemVuKhac: false,
  errorChiTietNhiemVuKhac: null,

  chiTietNhiemVuKhacThanhVien: [],
  loadingChiTietNhiemVuKhacThanhVien: false,
  errorChiTietNhiemVuKhacThanhVien: null,

  tongHopNhanVien: [],
  loadingTongHopNhanVien: false,
  errorTongHopNhanVien: null,
};

export const baoCaoSlice = createSlice({
  name: BAOCAO_MODULE.NAME_SLICE,
  initialState,
  reducers: {
    baoCaoClear: (state) => {
      state.tongQuanTeam = [];
      state.loading = false;
      state.error = null;
    },

    baoCaoClearThanhVienTeam: (state) => {
      state.thanhVienTeam = [];
      state.loadingThanhVienTeam = false;
      state.errorThanhVienTeam = null;
    },

    // [THÊM] clear Bảng 3
    baoCaoClearChiTiet: (state) => {
      state.chiTietNhanVien = null;
      state.loadingChiTietNhanVien = false;
      state.errorChiTietNhanVien = null;
    },
    
    // [THÊM] clear Chi tiết Phát triển phần mềm
    baoCaoClearChiTietPhatTrienPhanMem: (state) => {
      state.chiTietPhatTrienPhanMem = null;
      state.loadingChiTietPhatTrienPhanMem = false;
      state.errorChiTietPhatTrienPhanMem = null;
    },

    baoCaoClearChiTietXuLyYeuCau: (state) => {
      state.chiTietXuLyYeuCau = [];
      state.loadingChiTietXuLyYeuCau = false;
      state.errorChiTietXuLyYeuCau = null;
    },

    baoCaoClearChiTietXuLyYeuCauThanhVien: (state) => {
      state.chiTietXuLyYeuCauThanhVien = [];
      state.loadingChiTietXuLyYeuCauThanhVien = false;
      state.errorChiTietXuLyYeuCauThanhVien = null;
    },

    baoCaoClearChiTietHoTro: (state) => {
      state.chiTietHoTro = [];
      state.loadingChiTietHoTro = false;
      state.errorChiTietHoTro = null;
    },

    baoCaoClearChiTietHoTroThanhVien: (state) => {
      state.chiTietHoTroThanhVien = [];
      state.loadingChiTietHoTroThanhVien = false;
      state.errorChiTietHoTroThanhVien = null;
    },

    baoCaoClearChiTietNhiemVuKhac: (state) => {
      state.chiTietNhiemVuKhac = [];
      state.loadingChiTietNhiemVuKhac = false;
      state.errorChiTietNhiemVuKhac = null;
    },

    baoCaoClearChiTietNhiemVuKhacThanhVien: (state) => {
      state.chiTietNhiemVuKhacThanhVien = [];
      state.loadingChiTietNhiemVuKhacThanhVien = false;
      state.errorChiTietNhiemVuKhacThanhVien = null;
    },

    baoCaoClearTongHopNhanVien: (state) => {
      state.tongHopNhanVien = [];
      state.loadingTongHopNhanVien = false;
      state.errorTongHopNhanVien = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Bảng 1
      .addCase(baoCaoGetTongQuanTeamAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(baoCaoGetTongQuanTeamAction.fulfilled, (state, action) => {
        state.loading = false;
        state.tongQuanTeam = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(baoCaoGetTongQuanTeamAction.rejected, (state, action) => {
        state.loading = false;
        state.tongQuanTeam = [];
        state.error = action.payload || action.error;
      })

      // Bảng 2
      .addCase(baoCaoGetThanhVienTeamAction.pending, (state) => {
        state.loadingThanhVienTeam = true;
        state.errorThanhVienTeam = null;
      })
      .addCase(baoCaoGetThanhVienTeamAction.fulfilled, (state, action) => {
        state.loadingThanhVienTeam = false;
        state.thanhVienTeam = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(baoCaoGetThanhVienTeamAction.rejected, (state, action) => {
        state.loadingThanhVienTeam = false;
        state.thanhVienTeam = [];
        state.errorThanhVienTeam = action.payload || action.error;
      })

      // Tổng hợp tất cả nhân viên
      .addCase(baoCaoGetTongHopNhanVienAction.pending, (state) => {
        state.loadingTongHopNhanVien = true;
        state.errorTongHopNhanVien = null;
      })
      .addCase(baoCaoGetTongHopNhanVienAction.fulfilled, (state, action) => {
        state.loadingTongHopNhanVien = false;
        state.tongHopNhanVien = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(baoCaoGetTongHopNhanVienAction.rejected, (state, action) => {
        state.loadingTongHopNhanVien = false;
        state.tongHopNhanVien = [];
        state.errorTongHopNhanVien = action.payload || action.error;
      })

      // [THÊM] Bảng 3
      .addCase(baoCaoGetChiTietNhanVienAction.pending, (state) => {
        state.loadingChiTietNhanVien = true;
        state.errorChiTietNhanVien = null;
      })
      .addCase(baoCaoGetChiTietNhanVienAction.fulfilled, (state, action) => {
        state.loadingChiTietNhanVien = false;
        state.chiTietNhanVien = action.payload || null;
      })
      .addCase(baoCaoGetChiTietNhanVienAction.rejected, (state, action) => {
        state.loadingChiTietNhanVien = false;
        state.chiTietNhanVien = null;
        state.errorChiTietNhanVien = action.payload || action.error;
      })
      
      // [THÊM] Chi tiết Phát triển phần mềm
      .addCase(baoCaoGetChiTietPhatTrienPhanMemAction.pending, (state) => {
        state.loadingChiTietPhatTrienPhanMem = true;
        state.errorChiTietPhatTrienPhanMem = null;
      })
      .addCase(baoCaoGetChiTietPhatTrienPhanMemAction.fulfilled, (state, action) => {
        state.loadingChiTietPhatTrienPhanMem = false;
        state.chiTietPhatTrienPhanMem = action.payload || null;
      })
      .addCase(baoCaoGetChiTietPhatTrienPhanMemAction.rejected, (state, action) => {
        state.loadingChiTietPhatTrienPhanMem = false;
        state.chiTietPhatTrienPhanMem = null;
        state.errorChiTietPhatTrienPhanMem = action.payload || action.error;
      })

      // [THÊM] Chi tiết Xử lý yêu cầu
    .addCase(baoCaoGetChiTietXuLyYeuCauAction.pending, (state) => {
      state.loadingChiTietXuLyYeuCau = true;
      state.errorChiTietXuLyYeuCau = null;
    })
    .addCase(baoCaoGetChiTietXuLyYeuCauAction.fulfilled, (state, action) => {
      state.loadingChiTietXuLyYeuCau = false;
      state.chiTietXuLyYeuCau = Array.isArray(action.payload) ? action.payload : [];
    })
    .addCase(baoCaoGetChiTietXuLyYeuCauAction.rejected, (state, action) => {
      state.loadingChiTietXuLyYeuCau = false;
      state.chiTietXuLyYeuCau = [];
      state.errorChiTietXuLyYeuCau = action.payload || action.error;
    })

    .addCase(baoCaoGetChiTietXuLyYeuCauThanhVienAction.pending, (state) => {
      state.loadingChiTietXuLyYeuCauThanhVien = true;
      state.errorChiTietXuLyYeuCauThanhVien = null;
    })
    .addCase(baoCaoGetChiTietXuLyYeuCauThanhVienAction.fulfilled, (state, action) => {
      state.loadingChiTietXuLyYeuCauThanhVien = false;
      state.chiTietXuLyYeuCauThanhVien = Array.isArray(action.payload) ? action.payload : [];
    })
    .addCase(baoCaoGetChiTietXuLyYeuCauThanhVienAction.rejected, (state, action) => {
      state.loadingChiTietXuLyYeuCauThanhVien = false;
      state.chiTietXuLyYeuCauThanhVien = [];
      state.errorChiTietXuLyYeuCauThanhVien = action.payload || action.error;
    })
    .addCase(baoCaoGetChiTietHoTroAction.pending, (state) => {
      state.loadingChiTietHoTro = true;
      state.errorChiTietHoTro = null;
    })
    .addCase(baoCaoGetChiTietHoTroAction.fulfilled, (state, action) => {
      state.loadingChiTietHoTro = false;
      state.chiTietHoTro = Array.isArray(action.payload) ? action.payload : [];
    })
    .addCase(baoCaoGetChiTietHoTroAction.rejected, (state, action) => {
      state.loadingChiTietHoTro = false;
      state.chiTietHoTro = [];
      state.errorChiTietHoTro = action.payload || action.error;
    })

    .addCase(baoCaoGetChiTietHoTroThanhVienAction.pending, (state) => {
      state.loadingChiTietHoTroThanhVien = true;
      state.errorChiTietHoTroThanhVien = null;
    })
    .addCase(baoCaoGetChiTietHoTroThanhVienAction.fulfilled, (state, action) => {
      state.loadingChiTietHoTroThanhVien = false;
      state.chiTietHoTroThanhVien = Array.isArray(action.payload) ? action.payload : [];
    })
    .addCase(baoCaoGetChiTietHoTroThanhVienAction.rejected, (state, action) => {
      state.loadingChiTietHoTroThanhVien = false;
      state.chiTietHoTroThanhVien = [];
      state.errorChiTietHoTroThanhVien = action.payload || action.error;
    })
    .addCase(baoCaoGetChiTietNhiemVuKhacAction.pending, (state) => {
      state.loadingChiTietNhiemVuKhac = true;
      state.errorChiTietNhiemVuKhac = null;
    })
    .addCase(baoCaoGetChiTietNhiemVuKhacAction.fulfilled, (state, action) => {
      state.loadingChiTietNhiemVuKhac = false;
      state.chiTietNhiemVuKhac = Array.isArray(action.payload) ? action.payload : [];
    })
    .addCase(baoCaoGetChiTietNhiemVuKhacAction.rejected, (state, action) => {
      state.loadingChiTietNhiemVuKhac = false;
      state.chiTietNhiemVuKhac = [];
      state.errorChiTietNhiemVuKhac = action.payload || action.error;
    })

    .addCase(baoCaoGetChiTietNhiemVuKhacThanhVienAction.pending, (state) => {
      state.loadingChiTietNhiemVuKhacThanhVien = true;
      state.errorChiTietNhiemVuKhacThanhVien = null;
    })
    .addCase(baoCaoGetChiTietNhiemVuKhacThanhVienAction.fulfilled, (state, action) => {
      state.loadingChiTietNhiemVuKhacThanhVien = false;
      state.chiTietNhiemVuKhacThanhVien = Array.isArray(action.payload) ? action.payload : [];
    })
    .addCase(baoCaoGetChiTietNhiemVuKhacThanhVienAction.rejected, (state, action) => {
      state.loadingChiTietNhiemVuKhacThanhVien = false;
      state.chiTietNhiemVuKhacThanhVien = [];
      state.errorChiTietNhiemVuKhacThanhVien = action.payload || action.error;
    });
  },
});

export const {
  baoCaoClear,
  baoCaoClearThanhVienTeam,
  baoCaoClearChiTiet, // [THÊM]
  baoCaoClearChiTietPhatTrienPhanMem,
  baoCaoClearChiTietXuLyYeuCau,
  baoCaoClearChiTietXuLyYeuCauThanhVien,
  baoCaoClearChiTietHoTro,
  baoCaoClearChiTietHoTroThanhVien,
  baoCaoClearChiTietNhiemVuKhac,
  baoCaoClearChiTietNhiemVuKhacThanhVien,
  baoCaoClearTongHopNhanVien,
} = baoCaoSlice.actions;

export default baoCaoSlice.reducer;
